(() => {
  const root = document.querySelector('.vc-info-page__body');
  if (!root) return;

  const hasCJK = (s) => /[\u3400-\u9FFF]/.test(s);
  const englishChars = (s) => (s.match(/[A-Za-z]/g) || []).length;

  const children = Array.from(root.children);
  children.forEach((el, index) => {
    if (el.tagName !== 'P') return;
    const text = (el.textContent || '').replace(/\u00a0/g, ' ').trim();
    if (!text) {
      el.style.display = 'none';
      return;
    }

    // Normalize rich-text editors that stored bullets as a standalone paragraph.
    if (/^[•·▪●◦]$/.test(text)) {
      const next = children[index + 1];
      if (next && next.tagName === 'P') {
        el.classList.add('vc-doc-bullet-marker');
        next.classList.add('vc-doc-bullet-text');
      }
      return;
    }

    // On bilingual pages, let longer English-only paragraphs read as secondary copy.
    if (!hasCJK(text) && text.length >= 28 && englishChars(text) >= Math.max(18, text.length * 0.55)) {
      el.classList.add('vc-doc-secondary');
    }
  });
})();
